import React from 'react';
import { type SVGComponentProps } from '../../../../types/Svgs';

const StartPointIcon: React.FC<SVGComponentProps> = ({ primaryColor, secondaryColor, size }) => {
  return (
    <div>
      <svg
        width={size != null ? size[0].toString() : '17'}
        height={size != null ? size[1].toString() : '17'}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
            .primaryCar { stroke: ${primaryColor != null ? primaryColor : '#76919B'} }
            .secondaryCar { fill: ${secondaryColor != null ? secondaryColor : 'grey'} }
          `}
        </style>
        <circle cx="8.17236" cy="8.74316" r="5.5" fill="#fff" strokeWidth="5" className="primaryCar" />
      </svg>
    </div>
  );
};

export default StartPointIcon;
